import Page from "../../components/PageContainer/Page";
import SkillsItem from "../../components/common/SkillsItem/SkillsItem";
import SectionDivider from "../../components/common/SectionDivider/SectionDivider";
import TagCloud from "../../components/common/TagCloud/TagCloud";
import styles from "./Skills.module.scss";
import AnimatedWrapper from "../../components/common/AnimatedWrapper/AnimatedWrapper";
import { useTranslation } from 'react-i18next';

const Skills = () => {
  const { t } = useTranslation();
  const tags = ["vite", "git", "jira", "redux", "tailwind", "chart.js", "particles.js", "figma","redux-toolkit","next.js","primevue","material-design","ionic","firebase","typescript","nest.js","blender","Unity 3D", "linux", "CI/CD" ];

  return (
    <Page name="skills" background="white">
      <div className={styles.skills}>
        <div className={styles.skills__header}>
          <AnimatedWrapper>
          <h2 className={styles.skills__title}>{t('skills.title')}</h2>
          </AnimatedWrapper>
          <AnimatedWrapper>
          <SectionDivider />
          </AnimatedWrapper>
          <AnimatedWrapper>
          <p className={styles.skills__subtitle}>{t('skills.subtitle')}</p>
          </AnimatedWrapper>
        </div>
        <div className={styles.skills__grid}>
          <SkillsItem 
            icon="Code"
            title={t('skills.items.react_next.title')}
            description={t('skills.items.react_next.description')}
          />
          <SkillsItem 
            icon="Javascript"
            title={t('skills.items.js_ts.title')}
            description={t('skills.items.js_ts.description')}
          />
          <SkillsItem 
            icon="Web"
            title={t('skills.items.vue.title')}
            description={t('skills.items.vue.description')}
          />
          <SkillsItem 
            icon="Storage"
            title={t('skills.items.backend.title')}
            description={t('skills.items.backend.description')}
          />
          <SkillsItem 
            icon="DesignServices"
            title={t('skills.items.ui_ux.title')}
            description={t('skills.items.ui_ux.description')}
          />
          <SkillsItem 
            icon="AutoAwesome"
            title={t('skills.items.ai_content.title')}
            description={t('skills.items.ai_content.description')}
          />
        </div>

        <div className={styles.skills__moreSkills}>
          <AnimatedWrapper>
          <h3 className={styles.skills__moreSkills_title}>{t('skills.more_skills_title')}</h3>
          <div className={styles.skills__moreSkills_divider}></div>
          </AnimatedWrapper>
        </div>

        <div className={styles.skills__tagCloud}>
          <AnimatedWrapper> 
          <TagCloud tags={tags} />
          </AnimatedWrapper>
        </div>
      </div>
    </Page>
  );
};

export default Skills;
